import { useTheme } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';

import useClientMediaQuery from 'utils/useClientMediaQuery';
import { HashLink } from 'react-router-hash-link';

import { format } from 'date-fns';

const hotmobColorLogo = `${process.env.REACT_APP_BASE_URL}/img/static/footer/hotmob-color-logo-2x.webp`;
const facebook = `${process.env.REACT_APP_BASE_URL}/img/static/footer/facebook-black-2x.webp`;
const linkedin = `${process.env.REACT_APP_BASE_URL}/img/static/footer/linkedin-black-2x.webp`;

const Footer = () => {
    const theme = useTheme();

    const matchDownSm = useClientMediaQuery(theme.breakpoints.down('md'), { defaultMatches: false });

    return (
        <footer
            style={{
                display: 'flex',
                justifyContent: 'center',
                backgroundColor: '#FFFFFF',
                margin: '0 auto',
                padding: matchDownSm ? '20px' : '20px 24px',
                position: 'relative',
                zIndex: 90
            }}
        >
            <Grid container spacing={0} sx={{ width: '100% !important', maxWidth: '1280px', marginLeft: '0 !important' }}>
                <Grid
                    container
                    item
                    xs={12}
                    sx={(t) => ({
                        marginBottom: '40px',
                        [t.breakpoints.down(900)]: { marginBottom: '24px' }
                    })}
                >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box>
                                <img
                                    alt="hotmob-footer-logo"
                                    loading="lazy"
                                    width="120"
                                    height="48"
                                    src={hotmobColorLogo}
                                    style={{ width: matchDownSm ? '90px' : '120px', height: 'auto' }}
                                />
                            </Box>
                            {!matchDownSm && (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '20px'
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={(t) => ({
                                            color: '#787878',
                                            fontSize: '20px',
                                            marginTop: 0,
                                            fontWeight: 500,
                                            lineHeight: '100%',
                                            [t.breakpoints.down(900)]: { fontSize: '12px', lineHeight: '15.12px' }
                                        })}
                                    >
                                        Follow Us
                                    </Typography>
                                    <a href="https://www.facebook.com/HotmobMobile" target="_blank" rel="noreferrer">
                                        <Box
                                            component="img"
                                            alt="Facebook icon"
                                            loading="lazy"
                                            src={facebook}
                                            sx={{ width: '40px', height: '40px', cursor: 'pointer' }}
                                        />
                                    </a>
                                    <a href="https://www.linkedin.com/company/hotmob/" target="_blank" rel="noreferrer">
                                        <Box
                                            component="img"
                                            alt="Linkedin icon"
                                            loading="lazy"
                                            src={linkedin}
                                            sx={{ width: '40px', height: '40px', cursor: 'pointer' }}
                                        />
                                    </a>
                                </Box>
                            )}
                        </Box>
                    </Grid>
                </Grid>
                {matchDownSm && (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                            <Typography
                                component="a"
                                href="/privacy-policy"
                                sx={{
                                    color: '#787878',
                                    fontSize: '14px',
                                    marginTop: 0,
                                    fontWeight: 400,
                                    lineHeight: '17px',
                                    textDecoration: 'underline',
                                    cursor: 'pointer'
                                }}
                            >
                                Privacy Policy
                            </Typography>
                            <HashLink smooth to="/#about-us" style={{ textDecoration: 'none' }}>
                                <Typography
                                    variant="span"
                                    sx={{
                                        color: '#787878',
                                        fontSize: '14px',
                                        marginTop: 0,
                                        fontWeight: 400,
                                        lineHeight: '17px',
                                        textDecoration: 'underline',
                                        cursor: 'pointer'
                                    }}
                                >
                                    About Us
                                </Typography>
                            </HashLink>
                            <HashLink smooth to="/#contact-us" style={{ textDecoration: 'none' }}>
                                <Typography
                                    variant="span"
                                    sx={{
                                        color: '#787878',
                                        fontSize: '14px',
                                        marginTop: 0,
                                        fontWeight: 400,
                                        lineHeight: '17px',
                                        textDecoration: 'underline',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Contact Us
                                </Typography>
                            </HashLink>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '28px'
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: '#787878',
                                        fontSize: '14px',
                                        marginTop: 0,
                                        fontWeight: 500,
                                        lineHeight: '100%'
                                    }}
                                >
                                    Follow Us
                                </Typography>
                                <a href="https://www.facebook.com/HotmobMobile" target="_blank" rel="noreferrer">
                                    <Box
                                        component="img"
                                        alt="Facebook icon"
                                        loading="lazy"
                                        src={facebook}
                                        sx={{
                                            width: '24px',
                                            height: '24px',
                                            cursor: 'pointer'
                                        }}
                                    />
                                </a>
                                <a href="https://www.linkedin.com/company/hotmob/" target="_blank" rel="noreferrer">
                                    <Box
                                        component="img"
                                        alt="Linkedin icon"
                                        loading="lazy"
                                        src={linkedin}
                                        sx={{
                                            width: '24px',
                                            height: '24px',
                                            cursor: 'pointer'
                                        }}
                                    />
                                </a>
                            </Box>
                        </Box>
                    </Grid>
                )}
                <Grid
                    item
                    xs={12}
                    sx={(t) => ({
                        marginBottom: '40px',
                        [t.breakpoints.down(900)]: {
                            flexFlow: 'column-reverse'
                        }
                    })}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography
                            variant="h6"
                            sx={(t) => ({
                                color: '#787878',
                                fontSize: '18px',
                                marginTop: 0,
                                fontWeight: 400,
                                lineHeight: '25.2px',
                                [t.breakpoints.down(900)]: { fontSize: '12px', lineHeight: '15.12px' }
                            })}
                        >
                            Copyright © Hotmob Limited {format(new Date(), 'yyyy')}. All Rights Reserved.
                        </Typography>
                        {!matchDownSm && (
                            <Box
                                sx={(t) => ({
                                    display: 'flex',
                                    gap: '32px',
                                    [t.breakpoints.down(900)]: {
                                        minWidth: 'unset',
                                        justifyContent: 'space-between',
                                        marginBottom: '40px'
                                    }
                                })}
                            >
                                <Typography
                                    component="a"
                                    href="/privacy-policy"
                                    sx={(t) => ({
                                        color: '#787878',
                                        fontSize: '18px',
                                        marginTop: 0,
                                        fontWeight: 400,
                                        lineHeight: '25.2px',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                        [t.breakpoints.down(960)]: {
                                            fontSize: '0.75rem'
                                        }
                                    })}
                                >
                                    Privacy Policy
                                </Typography>
                                <HashLink smooth to="/#about-us">
                                    <Typography
                                        variant="span"
                                        sx={(t) => ({
                                            color: '#787878',
                                            fontSize: '18px',
                                            marginTop: 0,
                                            fontWeight: 400,
                                            lineHeight: '25.2px',
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                            [t.breakpoints.down(960)]: {
                                                fontSize: '0.75rem'
                                            }
                                        })}
                                    >
                                        About Us
                                    </Typography>
                                </HashLink>
                                <HashLink smooth to="/#contact-us">
                                    <Typography
                                        variant="span"
                                        sx={(t) => ({
                                            color: '#787878',
                                            fontSize: '18px',
                                            marginTop: 0,
                                            fontWeight: 400,
                                            lineHeight: '25.2px',
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                            [t.breakpoints.down(960)]: {
                                                fontSize: '0.75rem'
                                            }
                                        })}
                                    >
                                        Contact Us
                                    </Typography>
                                </HashLink>
                            </Box>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </footer>
    );
};

export default Footer;
